export default __webpack_public_path__ + "static/img/Letinte1.992db27.jpg";